<template>
    <div class="card">
        <div class="card-header">Preise speichern und laden</div>
        <div class="card-body">
            <button
                class="btn btn-primary"
                :disabled="articlesForExport.length === 0"
                @click="savePrices()"
            >
                Preise speichern
            </button>
            <hr />
            <label id="stored-price-select">Letzte Bepreisungen</label>
            <PriceList
                v-model="savedPricesToLoad"
                :saved-prices="savedPrices"
                @delete="savedPrice => deletePrices(savedPrice)"
            />
            <button class="btn btn-primary" :disabled="!savedPricesToLoad" @click="loadPrices">
                Preise laden
            </button>
        </div>
    </div>
</template>

<script>
import PriceList from "@/components/widgets/PriceList";
export default {
    name: "SaveLoadPricesVue",
    components: { PriceList },
    props: {
        articles: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            savedPricesToLoad: null
        };
    },
    computed: {
        articlesForExport() {
            // Only Export Articles, where a price is set
            return this.articles.filter(article => !!article.priceNew);
        },
        savedPrices() {
            return this.$store.state.saveLoadPrices.savedPrices.map(savedPrices => ({
                timestamp: savedPrices.timestamp,
                save_id: savedPrices.id,
                // name comes from pharmacyId or pharmacyGroupId
                name: savedPrices.pharmacyGroupId
                    ? (
                          this.$store.state.data.pharmacyGroup.find(
                              item => item.id === savedPrices.pharmacyGroupId
                          ) || { name: "Unbekannte Apothekengruppe" }
                      ).name
                    : (
                          this.$store.state.data.pharmacies.find(
                              item => item.id === savedPrices.pharmacyId
                          ) || { name: "Unbekannte Apotheke" }
                      ).name
            }));
        }
    },
    created() {
        this.$store.dispatch("loadSavedPrices");
        console.log(this.articlesForExport);
    },
    methods: {
        savePrices: function() {
            const priceList = this.articlesForExport.map(item =>
                (({ pzn, priceNew }) => ({ pzn, priceNew }))(item)
            );
            let id = {};

            if (this.$store.state.navSelection.isConsolidateModus) {
                id.pharmacyGroupId = this.$store.state.navSelection.pharmacyGroup.id;
            } else {
                id.pharmacyId = this.$store.state.navSelection.pharmacy.id;
            }

            this.$store.dispatch("addToSavedPrices", {
                ...id,
                articles: priceList.filter(article => article.priceNew)
            });
        },
        loadPrices: function() {
            this.$store.dispatch("loadPrices", this.savedPricesToLoad.save_id);
        },
        deletePrices: function(savedPrice) {
            this.$store.dispatch("deleteSavedPrices", savedPrice.save_id);
        }
    }
};
</script>

<style lang="scss" scoped>
.card-body > * {
    margin: 2px;
}

.card-body {
    display: flex;
    flex-direction: column;
}
#stored-price-select {
    margin: 8px 0;
}
</style>
